import React from 'react';

import { useState, useEffect, useRef, useContext } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Table } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import AppContext from '../AppContext';
import Loader from '../helper/Loader';

import TableHeader from '../helper/TableHeader';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    useReactTable,
} from '@tanstack/react-table';

const columnHelper = createColumnHelper();

const Userlist = () => {
    const { getSalutation } = useContext(AppContext);
    const { request } = useRequest();

    const [users, setUsers] = useState(false);

    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const getData = async () => {
        try {
            let result = await request("/User/GetUsers");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
                return;
            }

            setUsers(json.users.map(m => {
                return { ...m, SalutationID: getSalutation(m.SalutationID) };
            }));

        }
        catch(ex) {
            toast.error(ex.message);
        }
    };

    useEffect(() => {
        getData();
    }, []);


    const columns = [
        columnHelper.accessor('SalutationID', {
            header: () => <span>Anrede</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Title', {
            header: () => <span>Titel</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('FirstName', {
            header: () => <span>Vorname</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('LastName', {
            header: () => <span>Nachname</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Email', {
            header: () => <span>E-Mail</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('PhoneNo', {
            header: () => <span>Telefon</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
    ]

    const reactTable = useReactTable({
        data: users || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    if (!users) return <Loader />

    return (
        <Table striped responsive="xl">
            <thead>
                {reactTable.getHeaderGroups().map(headerGroup => (
                    <TableHeader key={headerGroup.id} table={reactTable} headerGroup={headerGroup} flexRender={flexRender} />
                ))}
            </thead>
            <tbody>
                {reactTable.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => {
                            return (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}

export default Userlist;